module.exports = __webpack_public_path__ + "img/list_1.1fa4ce06.png";